<template>
  <div class="animated fadeIn">
    <b-card header="게임등록/조회 > 목록">
      <b-button type="button" class="btn btn-sm" :to="{name: 'playGameNew'}" style="position: absolute; right: 1.25rem; font-weight: bold" variant="primary">신규게임 등록</b-button>
      <b-form-input id="game" v-model="search" placeholder="게임명을 입력해주세요." class="d-inline-block ml-2" style="width: 250px;"></b-form-input>
      <b-table class="mt-3" hover striped bordered small fixed responsive="sm" :items="filteredList" :fields="fields" :current-page="currentPage" :per-page="perPage" :show-empty=true empty-text="리스트가 없습니다." :sort-by="sortBy" :sort-desc="true">
        <template slot="number" slot-scope="data">
          {{ data.index + 1 }}
        </template>
        <template slot="appNameInfo.ko" slot-scope="data">
          <b-link :to="{name: 'playGameDetail', params: { appMasterId: data.item.appMasterId}}">{{data.item.appNameInfo.ko}}</b-link>
        </template>
        <template slot="genre" slot-scope="data">
          {{ data.item.genre && genreDesc[data.item.genre] ? genreDesc[data.item.genre]['ko'] : 'unknown'}}
        </template>
        <template slot="aosAppStartTime" slot-scope="data">
          {{ data.item.aos ? data.item.aos.appStartTime.format('YYYY-MM-DD HH:mm') : '비 설정' }}
        </template>
        <template slot="iosAppStartTime" slot-scope="data">
          {{ data.item.ios ? data.item.ios.appStartTime.format('YYYY-MM-DD HH:mm') :'비 설정' }}
        </template>
        <template slot="modStatusTime" slot-scope="data">
          {{ data.item.modStatusTime.format('YYYY-MM-DD HH:mm') }}
        </template>
        <template slot="edit" slot-scope="data">
          <b-link :to="{name: 'playGameDetail', params: { appMasterId: data.item.appMasterId}}">[조회]</b-link>
          <b-link :to="{name: 'playGameEdit', params: { appMasterId: data.item.appMasterId}}" class="ml-3" v-if="isInhouseLogin()">[수정]</b-link>
          <b-link :to="{name: 'playGameEditPartner', params: { appMasterId: data.item.appMasterId}}" class="ml-3" v-else>[수정]</b-link>
        </template>
      </b-table>
      <nav>
        <b-pagination :total-rows="this.filteredList.length" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
      </nav>
    </b-card>

    <guide-info :title="guideInfoTitle" :infoList="guideInfoList" v-if="isInhouseLogin()"></guide-info>
  </div>
</template>
<script>
  import {
    MODULE_NAME as PGM_MODULE,
    FETCH_PLAYGAME_LIST
  } from '@/store/playGame/actions.type'
  import {
    MODULE_NAME as AUTH_MODULE
  } from '@/store/auth/actions.type'
  import {
    $showModalWithErrorMsg,
    $isInhouseLogin
  } from '@/common/util'
  import { SHOW_MODAL } from '@/store/ui/mutations.type'
  import { mapState, mapGetters, mapMutations } from 'vuex'
  import { genreDesc, TABLE_CLASS_WITH_ELLIPSIS, TABLE_DATE_CLASS } from '@/constants'
  import GuideInfo from '@/components/GuideInfo.vue'
  export default {
    components: {
      GuideInfo
    },
    data () {
      return {
        guideInfoTitle: '게임등록 가이드 다운로드 안내',
        guideInfoList: [
          {
            link: '//www.dropbox.com/sh/g97kwbb2h35affr/AAA8m3AtV_tzI8ERHJDXYOIga?dl=0',
            text: '디자인 가이드'
          },
          {
            link: '//www.dropbox.com/sh/g97kwbb2h35affr/AAA8m3AtV_tzI8ERHJDXYOIga?dl=0',
            text: '어드민 이용 가이드'
          },
        ],
        search: '',
        currentPage: 1,
        perPage: 30,
        sortBy: 'modStatusTime',
        fields: [
          {key: 'number', label: 'No.', class: TABLE_CLASS_WITH_ELLIPSIS, thStyle: {width: '80px'}},
          {key: 'appNameInfo.ko', label: '게임명 (ko)', thStyle: {width: '180px', textAlign: 'center'}, class: 'text-center'},
          {key: 'appMasterId', label: '앱 마스터 ID', class: TABLE_CLASS_WITH_ELLIPSIS, thStyle: {width: '80px'}},
          {key: 'genre', label: '장르', class: TABLE_CLASS_WITH_ELLIPSIS, thStyle: {width: '100px'} },
          {key: 'aosAppStartTime', label: 'AOS 출시일', class: TABLE_CLASS_WITH_ELLIPSIS},
          {key: 'iosAppStartTime', label: 'iOS 출시일', class: TABLE_CLASS_WITH_ELLIPSIS},
          {key: 'modStatusTime', label: '등록/수정일', class: TABLE_CLASS_WITH_ELLIPSIS},
          {key: 'edit', label: '게임 관리', class: TABLE_CLASS_WITH_ELLIPSIS}
        ],
        genreDesc: genreDesc,
        isInhouseLogin: $isInhouseLogin.bind(this)
      }
    },
    computed: {
      filteredList() {
        return this.playGameListWithMoment.filter((elem) => {
          for (let lang in elem.appNameInfo) {
            if (elem.appNameInfo[lang] != null && elem.appNameInfo[lang].includes(this.search)) {
              return true
            }
          }
          return false
        })
      },
      ...mapGetters(PGM_MODULE, [
        'playGameListWithMoment'
      ]),
      ...mapState(AUTH_MODULE, [
        'auth'
      ])
    },
    mounted () {
      this.$store.dispatch(PGM_MODULE + FETCH_PLAYGAME_LIST)
        .catch($showModalWithErrorMsg.bind(this))

      if(this.isInhouseLogin()) {
        this.fields.splice(this.fields.length-2, 0, {key: 'modStatusUserId', label: '등록/수정자', class: TABLE_CLASS_WITH_ELLIPSIS, thStyle: {width: '150px'}})
      }
    },
    methods: {
      ...mapMutations('ui', [SHOW_MODAL])
    }

  }
</script>
<style scoped>
  .wrap {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -132px;
    margin-top: -115px;
    font-size: 0.75em;
    letter-spacing: -1px;
    text-align: center;
  }
  .btnBack {
    width: 264px;
    height: 36px;
    line-height: 35px;
    text-align: center;
    color: #574243;
    border-radius: 2px;
    background: #fdf01b;
    line-height: 35px;
    padding: 0 !important;
    border-bottom: 1px solid #ded318;
  }
</style>
